export type BubbleType = 'default' | 'primary' | 'info' | 'success' | 'warning' | 'error'

export const bubbleTypes = Object.freeze<BubbleType[]>([
  'default',
  'primary',
  'info',
  'success',
  'warning',
  'error',
])
